import { ThemeEvents } from '@theme/events';

/**
 * Shows the kit details metafield for the currently selected variant.
 */
class KitDetails extends HTMLElement {
  /** @type {AbortController} */
  #abortController = new AbortController();

  connectedCallback() {
    const { signal } = this.#abortController;
    const section = this.closest('.shopify-section, dialog');

    section?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate, { signal });
  }

  disconnectedCallback() {
    this.#abortController.abort();
  }

  /**
   * @param {import('@theme/events').VariantUpdateEvent} event
   */
  #onVariantUpdate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const variantId = event.detail.resource?.id != null ? String(event.detail.resource.id) : '';
    if (!variantId) return;

    this.querySelectorAll('[data-variant-id]').forEach((el) => {
      const isActive = el.getAttribute('data-variant-id') === variantId;
      el.classList.toggle('active', isActive);
      el.toggleAttribute('hidden', !isActive);
    });
  };
}

if (!customElements.get('kit-details')) {
  customElements.define('kit-details', KitDetails);
}
